<script lang="ts">
import { Image } from '@builder.io/sdk-svelte';
import {
    EMAIL,
    LOCATION,
    LOCATION_LINK,
    MAIL_TO,
    PHONE,
    PHONE_FORMATTED,
    SOCIAL_INSTAGRAM,
    SOCIAL_LINKEDIN,
} from '../../../config/constants.js';
import { ERoutes } from '../../../config/enums.js';
import Ecologi from '../../../images/ecologi.png';
import PLIN from '../../../images/PL_ImpactNet_Logo.svg';
import { isContactOpen } from '../../../utils/store';
import Link from '../../atoms/Link/Link.svelte';
import LinkList from '../../molecules/LinkList/LinkList.svelte';
import Newsletter from '../../molecules/Newsletter/Newsletter.svelte';

let { skywireMenu = [], cookieOnClick, newsletterTitle = '', newsletterText = '' } = $props();

const year = new Date().getFullYear();
const links = $derived(
    skywireMenu.map((link) => {
        return {
            text: link.text,
            to: link.link,
        };
    }),
);

const addressLines = LOCATION.split(/<br\s*\/?>\s*/i).map((line) => line.trim());

function goTop() {
    document.body.scrollIntoView({ behavior: 'smooth' });
}
</script>

<footer class="footer">
    <div class="footer__row footer__row--first">
        <div class="footer__col">
            <h2 class="footer__col-header">Skywire</h2>
            <LinkList class="linklist final-links" items={links} />
        </div>
        <div class="footer__col">
            <h2 class="footer__col-header">Contact</h2>
            <ul class="linklist contact-links">
                <li class="linklist__item">
                    <Link to={MAIL_TO}>
                        {#snippet text()}
                            <svg
                                width="28"
                                height="22"
                                viewBox="0 0 28 22"
                                class="svg svg--mail"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <path d="M23.9227 18.9996H5.0769C4.48461 18.9996 4 18.4597 4 17.7997V5.19997C4 4.53999 4.48461 4 5.0769 4H23.9227C24.5149 4 24.9996 4.53999 24.9996 5.19997V17.7997C24.9996 18.4597 24.5149 18.9996 23.9227 18.9996Z" stroke="currentColor" stroke-miterlimit="10"/>
                                <path d="M24.4614 4.59999L15.8462 12.9998C15.3077 13.5998 14.2308 13.5998 13.6924 12.9998L4.53873 4" stroke="currentColor" stroke-miterlimit="10"/>
                                <path d="M4.53873 19L12.077 11.2002" stroke="currentColor" stroke-miterlimit="10"/>
                                <path d="M24.4614 18.9996L17.4615 11.7998" stroke="currentColor" stroke-miterlimit="10"/>
                            </svg>
                            <span>{EMAIL}</span>
                        {/snippet}
                    </Link>
                </li>
                <li class="linklist__item">
                    <Link to={`tel:${PHONE}`}>
                        {#snippet text()}
                            <svg
                                width="28"
                                height="22"
                                viewBox="0 0 28 22"
                                class="svg svg--telephone"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <g clip-path="url(#clip0_7170_16615)">
                                    <path d="M8.68887 1.68887C9.09794 1.27981 9.65275 1.05 10.2312 1.05H18.3687C18.9473 1.05 19.5021 1.27981 19.9111 1.68887C20.3202 2.09794 20.55 2.65275 20.55 3.23125V19.7687C20.55 20.3473 20.3202 20.9021 19.9111 21.3111C19.5021 21.7202 18.9473 21.95 18.3687 21.95H10.2312C9.65275 21.95 9.09794 21.7202 8.68887 21.3111C8.27981 20.9021 8.05 20.3473 8.05 19.7687V3.23125C8.05 2.65275 8.27981 2.09794 8.68887 1.68887ZM10.2312 2.2625C9.69649 2.2625 9.2625 2.69649 9.2625 3.23125V19.7687C9.2625 20.0257 9.36456 20.2721 9.54624 20.4538C9.72792 20.6354 9.97432 20.7375 10.2312 20.7375H18.3687C18.6257 20.7375 18.8721 20.6354 19.0538 20.4538C19.2354 20.2721 19.3375 20.0257 19.3375 19.7687V3.23125C19.3375 2.6965 18.9041 2.2625 18.3687 2.2625H10.2312ZM12.4276 17.7651C12.5413 17.6514 12.6955 17.5875 12.8562 17.5875H15.7437C15.9045 17.5875 16.0587 17.6514 16.1724 17.7651C16.2861 17.8788 16.35 18.033 16.35 18.1938C16.35 18.3545 16.2861 18.5087 16.1724 18.6224C16.0587 18.7361 15.9045 18.8 15.7437 18.8H12.8562C12.6955 18.8 12.5413 18.7361 12.4276 18.6224C12.3139 18.5087 12.25 18.3545 12.25 18.1938C12.25 18.033 12.3139 17.8788 12.4276 17.7651Z" fill="black" stroke="#F4F2EF" stroke-width="0.1"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_7170_16615">
                                        <rect width="28" height="22" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <span>{PHONE_FORMATTED}</span>
                        {/snippet}
                    </Link>
                </li>
                <li class="linklist__item">
                    <Link to={LOCATION_LINK}>
                        {#snippet text()}
                            <svg
                                width="28"
                                height="22"
                                viewBox="0 0 28 22"
                                class="svg svg--location"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <path d="M13.8795 10.6898C14.3738 10.6898 14.7955 10.514 15.1448 10.1626C15.4941 9.81107 15.6687 9.38818 15.6687 8.89389C15.6687 8.3996 15.4929 7.97782 15.1415 7.62856C14.7892 7.2793 14.3664 7.10467 13.8728 7.10467C13.3792 7.10467 12.9575 7.28078 12.6075 7.633C12.2582 7.98448 12.0836 8.40737 12.0836 8.90166C12.0836 9.39595 12.2593 9.81773 12.6108 10.167C12.963 10.5163 13.3859 10.6909 13.8795 10.6909M13.8761 19.5105C15.9628 17.6946 17.6122 15.848 18.8242 13.9708C20.0363 12.0927 20.6423 10.4685 20.6423 9.09812C20.6423 7.06767 19.9997 5.39166 18.7144 4.07009C17.429 2.74852 15.8163 2.08811 13.8761 2.08885C11.9367 2.08885 10.324 2.74926 9.0379 4.07009C7.75185 5.39092 7.1092 7.06693 7.10994 9.09812C7.10994 10.4685 7.71597 12.0927 8.92802 13.9708C10.1408 15.848 11.7902 17.6953 13.8761 19.5105ZM13.8761 21C11.2678 18.6935 9.30318 16.5425 7.98235 14.5468C6.66078 12.5511 6 10.7349 6 9.09812C6 6.75023 6.76438 4.81375 8.29313 3.2887C9.82263 1.7629 11.6836 1 13.8761 1C16.0686 1 17.9296 1.7629 19.4591 3.2887C20.9879 4.81375 21.7523 6.75023 21.7523 9.09812C21.7523 10.7349 21.0918 12.5511 19.771 14.5468C18.4495 16.5425 16.4845 18.6935 13.8761 21Z" fill="currentColor"/>
                            </svg>
                            <span>
                                {#each addressLines as line, index}
                                    {#if index > 0}<br />{/if}{line}
                                {/each}
                            </span>
                        {/snippet}
                    </Link>
                </li>
            </ul>
            <ul class="linklist social-links">
                <li class="linklist__item">
                    <Link to={SOCIAL_INSTAGRAM}>
                        {#snippet text()}
                            <svg
                                width="28"
                                height="22"
                                viewBox="0 0 28 22"
                                class="svg svg--instagram"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <path d="M17.7271 2.65934L17.7268 2.65932C16.6943 2.60906 16.2983 2.60906 13.7555 2.60906H13.7506C12.4254 2.60906 11.6885 2.63416 11.1546 2.65297L11.1255 2.654C10.6096 2.67219 10.2872 2.68356 9.78901 2.65932L9.78148 2.65895L9.77396 2.65934C8.78511 2.71058 8.27709 2.86244 7.91442 3.02118C7.45574 3.17804 7.09395 3.39072 6.73428 3.75958L6.72563 3.76846L6.71854 3.77864C6.6814 3.83204 6.64379 3.88485 6.60601 3.93791C6.40033 4.22675 6.1893 4.52312 6.01694 4.9641C5.86199 5.33515 5.71244 5.85503 5.66303 6.87225L5.66301 6.8726C5.61401 7.93143 5.61401 8.33717 5.61401 10.9468V10.9499V10.953C5.61401 13.6628 5.61401 13.9684 5.66301 15.0272L5.66303 15.0277C5.71295 16.041 5.86086 16.5608 6.01522 16.9316C6.16775 17.4009 6.37461 17.7714 6.73428 18.1403L6.74301 18.1492L6.75311 18.1566C6.8051 18.1946 6.85653 18.2332 6.90823 18.2719C7.18982 18.4828 7.47937 18.6997 7.91014 18.8768C8.27301 19.0362 8.78114 19.1898 9.77406 19.2405L9.77443 19.2405C10.8069 19.2908 11.1053 19.2908 13.7455 19.2908H13.7506H13.7557C16.3959 19.2908 16.6943 19.2908 17.7268 19.2405L17.7272 19.2405C18.7161 19.1893 19.2241 19.0374 19.5868 18.8787C20.0454 18.7218 20.4072 18.5091 20.7669 18.1403L20.7756 18.1314L20.7826 18.1212C20.8198 18.0678 20.8574 18.015 20.8952 17.9619C21.1009 17.6731 21.3119 17.3767 21.4842 16.9357C21.6392 16.5647 21.7887 16.0448 21.8382 15.0276L21.8382 15.0272C21.8872 13.9686 21.8872 13.5628 21.8872 10.9545V10.9499V10.9452C21.8872 8.2369 21.8872 7.93122 21.8382 6.8726L21.8382 6.87215C21.7882 5.85885 21.6403 5.33905 21.486 4.96821C21.3334 4.49896 21.1266 4.12845 20.7669 3.75958L20.7582 3.75062L20.7481 3.74324C20.6961 3.7052 20.6446 3.66667 20.5929 3.62795C20.3113 3.41703 20.0218 3.20015 19.591 3.02305C19.2281 2.86366 18.72 2.71007 17.7271 2.65934ZM5.77307 2.813L5.77317 2.8131L5.7775 2.80826C6.29152 2.23335 6.80219 1.99185 7.43461 1.69278L7.44499 1.68786C8.05836 1.3978 8.72365 1.24938 9.74018 1.1999C10.7647 1.15003 11.1041 1.15 13.7506 1.15C16.3967 1.15 16.6877 1.15003 17.7611 1.19991C18.6675 1.24404 19.2992 1.44669 19.8838 1.63423C19.9456 1.65407 20.0069 1.67375 20.068 1.69305C20.6399 1.93871 21.2077 2.27927 21.7281 2.813L21.728 2.8131L21.7327 2.81755C22.2936 3.345 22.5294 3.86944 22.8213 4.51858L22.8259 4.52886C23.1093 5.1592 23.2542 5.84292 23.3025 6.88647C23.3512 7.93752 23.3512 8.28587 23.3512 11C23.3512 13.7141 23.3512 14.0625 23.3025 15.1135C23.2594 16.0447 23.0614 16.6937 22.8786 17.2933C22.8592 17.3569 22.84 17.4199 22.8211 17.4826C22.5812 18.0701 22.2487 18.653 21.7281 19.187L21.728 19.1869L21.7237 19.1917C21.2097 19.7667 20.699 20.0082 20.0666 20.3072L20.0562 20.3121C19.4428 20.6022 18.7775 20.7506 17.761 20.8001C16.7365 20.85 16.3971 20.85 13.7506 20.85C11.1041 20.85 10.7647 20.85 9.74018 20.8001C8.83373 20.756 8.20202 20.5533 7.61742 20.3658C7.55557 20.3459 7.49424 20.3263 7.43318 20.307C6.86127 20.0613 6.29349 19.7207 5.77307 19.187L5.77317 19.1869L5.76843 19.1824C5.20756 18.655 4.97177 18.1306 4.67991 17.4814L4.67529 17.4711C4.39187 16.8408 4.24696 16.1571 4.19867 15.1135C4.15003 14.0625 4.15 13.7141 4.15 11C4.15 8.28587 4.15003 7.93752 4.19867 6.88647C4.24176 5.95533 4.43974 5.30625 4.62262 4.70669C4.64201 4.64311 4.66123 4.58009 4.68009 4.51734C4.91998 3.92983 5.25245 3.34694 5.77307 2.813Z" fill="currentColor" stroke="white" stroke-width="0.3"/>
                                <path d="M17.1829 10.9576L17.1831 10.9576V10.9498C17.1831 9.0113 15.6498 7.43328 13.7506 7.43328C11.8513 7.43328 10.3181 9.0113 10.3181 10.9498C10.3181 12.8882 11.8513 14.4662 13.7506 14.4662C15.556 14.4662 17.0816 12.8856 17.1829 10.9576ZM8.90287 10.9498C8.90287 8.16472 11.0441 5.97422 13.7506 5.97422C16.3613 5.97422 18.5983 8.16664 18.5983 10.9498C18.5983 13.7348 16.457 15.9253 13.7506 15.9253C11.0441 15.9253 8.90287 13.7348 8.90287 10.9498Z" fill="currentColor" stroke="white" stroke-width="0.3"/>
                                <path d="M19.9214 5.72367C19.9214 6.31053 19.4585 6.77977 18.8954 6.77977C18.3323 6.77977 17.8694 6.31053 17.8694 5.72367C17.8694 5.13681 18.3323 4.66758 18.8954 4.66758C19.4585 4.66758 19.9214 5.13681 19.9214 5.72367Z" fill="currentColor" stroke="white" stroke-width="0.3"/>
                            </svg>
                            <span>skywire_agency</span>
                        {/snippet}
                    </Link>
                </li>
                <li class="linklist__item">
                    <Link to={SOCIAL_LINKEDIN}>
                        {#snippet text()}
                            <svg
                                width="28"
                                height="22"
                                viewBox="0 0 28 22"
                                class="svg svg--linkedin"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <path d="M8.90954 8.00411H4.91081C4.77824 8.00411 4.6511 8.05677 4.55737 8.15051C4.46363 8.24425 4.41097 8.37138 4.41097 8.50395V20.5002C4.41097 20.6327 4.46363 20.7599 4.55737 20.8536C4.6511 20.9473 4.77824 21 4.91081 21H8.90954C9.04211 21 9.16925 20.9473 9.26299 20.8536C9.35672 20.7599 9.40939 20.6327 9.40939 20.5002V8.50395C9.40939 8.37138 9.35672 8.24425 9.26299 8.15051C9.16925 8.05677 9.04211 8.00411 8.90954 8.00411ZM8.4097 20.0003H5.41065V9.00379H8.4097V20.0003ZM19.4062 8.00411C18.3216 8.00411 17.2669 8.36199 16.4072 9.02279V8.50395C16.4072 8.37138 16.3545 8.24425 16.2608 8.15051C16.167 8.05677 16.0399 8.00411 15.9073 8.00411H11.9086C11.776 8.00411 11.6489 8.05677 11.5552 8.15051C11.4614 8.24425 11.4088 8.37138 11.4088 8.50395V20.5002C11.4088 20.6327 11.4614 20.7599 11.5552 20.8536C11.6489 20.9473 11.776 21 11.9086 21H15.9073C16.0399 21 16.167 20.9473 16.2608 20.8536C16.3545 20.7599 16.4072 20.6327 16.4072 20.5002V15.0019C16.4072 14.6042 16.5652 14.2228 16.8464 13.9416C17.1276 13.6604 17.509 13.5024 17.9067 13.5024C18.3044 13.5024 18.6858 13.6604 18.967 13.9416C19.2482 14.2228 19.4062 14.6042 19.4062 15.0019V20.5002C19.4062 20.6327 19.4589 20.7599 19.5526 20.8536C19.6464 20.9473 19.7735 21 19.9061 21H23.9048C24.0374 21 24.1645 20.9473 24.2582 20.8536C24.352 20.7599 24.4046 20.6327 24.4046 20.5002V13.0025C24.4031 11.6774 23.8759 10.4069 22.9389 9.46986C22.0019 8.53282 20.7314 8.00569 19.4062 8.00411ZM23.405 20.0003H20.4059V15.0019C20.4059 14.3391 20.1426 13.7034 19.6739 13.2347C19.2052 12.766 18.5695 12.5027 17.9067 12.5027C17.2439 12.5027 16.6082 12.766 16.1395 13.2347C15.6708 13.7034 15.4075 14.3391 15.4075 15.0019V20.0003H12.4084V9.00379H15.4075V10.2064C15.4075 10.3099 15.4396 10.4109 15.4994 10.4954C15.5593 10.5799 15.6438 10.6437 15.7415 10.6781C15.8392 10.7124 15.9451 10.7156 16.0446 10.6871C16.1442 10.6587 16.2324 10.6001 16.2972 10.5193C16.8106 9.86859 17.5142 9.39429 18.31 9.16256C19.1058 8.93082 19.954 8.95319 20.7365 9.22656C21.519 9.49993 22.1966 10.0107 22.675 10.6875C23.1533 11.3644 23.4085 12.1737 23.405 13.0025V20.0003ZM7.27806 1.00832C7.16057 1.00073 7.04274 1.00006 6.92517 1.00632C6.55106 0.980864 6.1757 1.03249 5.82235 1.15801C5.46901 1.28353 5.14519 1.48026 4.87097 1.73602C4.59675 1.99177 4.37796 2.30111 4.22816 2.64487C4.07836 2.98863 4.00074 3.35948 4.00009 3.73446C3.99699 4.10552 4.07015 4.47326 4.21503 4.81488C4.35991 5.1565 4.57343 5.46472 4.84234 5.72041C5.11126 5.97611 5.42983 6.17384 5.77831 6.30134C6.1268 6.42883 6.49776 6.48338 6.86819 6.46159H6.89618C7.25425 6.48667 7.61375 6.44097 7.95415 6.32711C8.29456 6.21325 8.60921 6.03346 8.88013 5.798C9.15105 5.56253 9.37294 5.27602 9.53314 4.9548C9.69333 4.63359 9.78868 4.28396 9.81376 3.9259C9.83883 3.56783 9.79313 3.20833 9.67927 2.86792C9.56541 2.52752 9.38562 2.21287 9.15016 1.94195C8.9147 1.67102 8.62818 1.44913 8.30696 1.28894C7.98575 1.12875 7.63613 1.03339 7.27806 1.00832ZM7.24307 5.46491C7.12777 5.47557 7.01214 5.47457 6.89618 5.46191H6.86819C6.62759 5.48 6.38587 5.44772 6.15845 5.36713C5.93103 5.28654 5.72292 5.15942 5.54739 4.99388C5.37186 4.82834 5.23278 4.62802 5.13903 4.40571C5.04527 4.18339 4.9989 3.94397 5.00288 3.70273C5.00686 3.46149 5.06109 3.22373 5.16213 3.00463C5.26316 2.78552 5.40877 2.5899 5.58966 2.43023C5.77055 2.27057 5.98274 2.15038 6.21269 2.07733C6.44265 2.00429 6.6853 1.97999 6.92517 2.006C7.38385 1.96385 7.84049 2.10563 8.19463 2.40015C8.54878 2.69468 8.77142 3.11783 8.81357 3.57651C8.85573 4.03519 8.71395 4.49183 8.41942 4.84597C8.1249 5.20011 7.70175 5.42275 7.24307 5.46491Z" fill="black" stroke="#F4F2EF" stroke-width="0.15"/>
                            </svg>
                            <span>skywire-agency</span>
                        {/snippet}
                    </Link>
                </li>
            </ul>
            <Link
                to={ERoutes.Contact}
                type="button"
                class="button button--inverse button--with-border footer__cta"
                onClick={() => {
                    $isContactOpen = true;
                }}
            >
                {#snippet text()}
                                Enquire Now
                            {/snippet}
            </Link>
        </div>
        <div class="footer__col footer__col--large">
            <Newsletter {newsletterTitle} {newsletterText} source="footer" />
        </div>
    </div>

    <div class="footer__row footer__row--centered">
        <div class="footer__absolute-footer-links">
            <span class="copyright">© {year} Skywire Limited.</span>
            <a href={ERoutes.Privacy} class="privacy">Privacy Policy</a>
            <a href="#cookie-settings" onclick={cookieOnClick} class="cookie">Cookie Settings</a>
        </div>
        <div class="logos-container">
            <a
                class="foot-logo foot-logo--pl"
                href="{ERoutes.TheWire}/skywire-is-proud-to-support-positive-luxury"
            >
                <Image image={PLIN} altText="Positive Luxury Impact Network" />
            </a>
            <a
                class="foot-logo foot-logo--eco"
                href="https://ecologi.com/skywire?r=661557f2df0d55cf4482b7c5"
                target="_blank"
                rel="noopener noreferrer"
            >
                <Image image={Ecologi} altText="Ecologi - Climate Action Workforce" />
            </a>
        </div>
        <a class="back-to-top" href="#body" onclick={goTop}>Back to Top</a>
    </div>
</footer>

<style lang="scss">
    @use '/src/scss/global-constants/fonts';
    @use '/src/scss/global-constants/typography';
    @use 'sass-mq/mq' as *;

    .footer {
        background-color: var(--colour-classic-chalk);
        margin-top: var(--layout-section-gap);
        padding: var(--layout-pagegrid-margin);
        position: relative;
        z-index: 1;

        @include mq($until: tabletLarge) {
            padding-top: 5rem;
        }

        &__row {
            display: flex;
            flex-wrap: wrap;
            padding-bottom: 5rem;
            row-gap: 5rem;

            @include mq($from: tabletLarge) {
                gap: 0;
                grid-template-columns: repeat(3, 1fr);
                display: grid;
            }

            &--first {
                @include mq($from: tabletLarge) {
                    border-top: 1px solid var(--colour-dreamless-sleep);
                    padding-top: var(--layout-pagegrid-margin);
                }
            }
            &--centered {
                align-items: center;
                gap: 0;
                justify-content: space-between;
                padding-bottom: 0;
                width: 100%;

                @include mq($until: tabletLarge) {
                    text-align: center;
                }
            }
        }

        &__absolute-footer-links {
            display: flex;
            flex-direction: column;
            flex: 1;

            @include mq($until: tabletLarge) {
                align-items: center;
                column-gap: 2rem;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: center;
                padding-bottom: 3rem;
            }

            @include mq($from: tabletLarge) {
                display: block;
            }
        }

        .cookie,
        .privacy,
        .copyright {
            color: var(--colour-squant);
            font-family: fonts.$fonts-secondary;
            font-size: 1.5rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.7;
            min-width: fit-content;

            @include mq($until: tabletLarge) {
                padding-bottom: 3rem;
                width: 100%;
            }
        }

        .cookie,
        .privacy {
            @include mq($until: tabletLarge) {
                padding-bottom: 0;
                width: auto;
            }

            @include mq($from: tabletLarge) {
                padding-left: 2rem;
            }
        }

        .back-to-top {
            align-items: center;
            color: var(--colour-dreamless-sleep);
            cursor: pointer;
            display: flex;
            font-size: 1.5rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.7;
            min-width: fit-content;

            @include mq($until: tabletLarge) {
                margin: 0 auto;
            }

            @include mq($from: tabletLarge) {
                margin-left: auto;
            }

            &::after {
                background-size: cover;
                background: url(/src/stories/assets/arrow-up.svg) no-repeat center center;
                content: '';
                display: block;
                height: 1.4rem;
                width: 1.4rem;
            }
        }

        .logos-container {
            align-items: center;
            display: flex;
            flex-direction: row;
            gap: 2rem;
            justify-content: center;
            padding-bottom: 3rem;
            width: 100%;

            @include mq($from: tabletLarge) {
                flex-direction: row;
                gap: 4.5rem;
                padding-bottom: 0;
            }
        }

        .foot-logo {
            &--pl {
                max-width: 6.5rem;
            }
            &--eco {
                max-width: 8.5rem;
            }
            @include mq($until: tabletLarge) {
                width: 100%;
                &--eco {
                    max-width: 12.2rem;
                }
            }
        }

        &__col {
            flex: 0 0 50%;

            @include mq($from: tabletLarge) {
                flex: 0 0 31%;
            }
        }

        &__col--large {
            flex: 0 0 100%;

            @include mq($from: tabletLarge) {
                flex: 0 0 38%;
                padding-top: 0;
            }
        }

        &__col-header {
            color: var(--colour-black-out);
            padding-bottom: 3.3rem;
            @include typography.heading-md;
        }

        :global(.linklist__item) {
            padding-bottom: 2.2rem;
        }

        :global(.linklist__item a) {
            display: flex;
            align-items: flex-start;
        }


        :global(.linklist__item a) {
            color: var(--colour-black-out);
            font-size: 1.4rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3;

            @include mq($from: tabletLarge) {
                font-size: 1.6rem;
            }
        }

        :global(.footer__cta) {
            display: inline-block;
        }

        :global(.svg) {
            color: var(--colour-black-out);
            margin-right: 1rem;
        }


        :global(.svg--mail) {
            width: 2.8rem;
        }

        :global(.svg--telephone) {
            width: 2.8rem;
        }

        :global(.svg--location) {
            width: 2.8rem;
        }

        :global(.svg--instagram),
        :global(.svg--linkedin) {
            width: 2.8rem;
        }
    }
</style>
